module.exports = __webpack_public_path__ + "static/media/Bet9ja Logo.873ffb87.svg";